import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b7926d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "application-container" }
const _hoisted_2 = {
  key: 0,
  class: "content-wrapper"
}
const _hoisted_3 = {
  key: 1,
  class: "content-wrapper"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "노선 수요조사 신청을 취소하시겠습니까?", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], {
          title: "노선 수요조사",
          overrideOnClickBack: true,
          onOnClickBack: $setup.handleClickBack
        }),
        ($setup.editMode)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              ($setup.filters)
                ? (_openBlock(), _createBlock($setup["RouteDemandSurveyEdit"], {
                    key: 0,
                    filters: $setup.filters,
                    createMode: $setup.createMode,
                    onOnClickApplyBtn: $setup.updateLineDemandSurveyAnswer
                  }, null, 8 /* PROPS */, ["filters", "createMode"]))
                : _createCommentVNode("v-if", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              ($setup.lineDemandSurveyAnswer)
                ? (_openBlock(), _createBlock($setup["RouteDemandSurveyDetail"], {
                    key: 0,
                    lineDemandSurveyAnswer: $setup.lineDemandSurveyAnswer!,
                    lineDemandSurvey: $setup.lineDemandSurvey,
                    onOnClickEditBtn: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleEditMode(true))),
                    onOnClickDeleteBtn: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowDeleteConfirmModal(true)))
                  }, null, 8 /* PROPS */, ["lineDemandSurveyAnswer", "lineDemandSurvey"]))
                : _createCommentVNode("v-if", true)
            ]))
      ]),
      ($setup.shouldShowDeleteConfirmModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 0,
            title: "노선 수요조사 신청 취소",
            cancelButtonTitle: "닫기",
            onOnClickCancelButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowDeleteConfirmModal(false))),
            okButtonTitle: "신청 취소",
            onOnClickOkButton: _cache[3] || (_cache[3] = ($event: any) => (
        [$setup.toggleShowDeleteConfirmModal(false), $setup.deleteLineDemandSurveyAnswer()]
      ))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}